<template>
    <li class="s-side-menu-control__item">
        <component
            :is="tag"
            class="s-side-menu-control__element"
            :class="className"
            v-bind="bindAttrs"
            @click="onClick"
        >
            {{ label }}

            <span
                v-if="showCounter"
                class="s-side-menu-control__element-counter"
            >
                {{ counter }}
            </span>
        </component>
    </li>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    tag: {
        type: String,
        default: 'button',
    },
    label: {
        type: String,
        required: true,
    },
    href: {
        type: String,
        default: undefined,
    },
    className: {
        type: [String, Array, Object],
        default: null,
    },
    showCounter: {
        type: Boolean,
        default: false,
    },
    counter: {
        type: [String, Number],
        default: null,
    },
});

const emit = defineEmits(['click']);

const bindAttrs = computed(() => {
    if (props.tag === 'a') {
        return { href: props.href };
    }

    return { type: 'button' };
});

function onClick(event) {
    emit('click', event);
}
</script>
